export enum NamingConventionItemType {
  FreeText,
  Date,
  // eslint-disable-next-line id-blacklist
  DPRNumber,
  RevisionNumber,
  Separator,
  FileNumber,
  ProjectName,
  ProjectAbbreviation,
  ScopeName,
  VesselLocationName,
}
